import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useStyles = createUseStyles((theme: Theme) => ({
  dialogPaper: {
    backgroundColor: theme.colors.espresso_brown,
    padding: theme.spacing(6),
    marginTop: theme.spacing(15),
    position: 'relative',
    borderRadius: '12px',
    maxWidth: '600px',
    color: theme.colors.ivory_beige,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
      margin: theme.spacing(2),
      maxWidth: '95vw',
      marginTop: theme.spacing(8),
    },
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(0),
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: theme.colors.desert_sand_gold,
    color: theme.colors.espresso_brown,
    width: '50px',
    height: '50px',
    zIndex: 1000,
    '&:hover': {
      backgroundColor: theme.colors.golden_mustard,
      transform: 'translateX(-50%) scale(1.1)',
    },
  },
  title: {
    fontFamily: theme.fonts.poplar,
    fontSize: '3.5rem',
    color: theme.colors.ivory_beige,
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.5rem',
    },
  },
  subtitle: {
    fontFamily: theme.fonts.poplar,
    fontSize: '2.5rem',
    marginBottom: theme.spacing(3),
    color: theme.colors.ivory_beige,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.8rem',
    },
  },
  highlight: {
    color: theme.colors.desert_sand_gold,
  },
  description: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    lineHeight: 1.6,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  boldHighlight: {
    fontWeight: 'bold',
    color: theme.colors.desert_sand_gold,
  },
  instructions: {
    marginBottom: theme.spacing(1),
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  caption: {
    fontSize: '0.75rem',
    marginBottom: theme.spacing(4),
    opacity: 0.8,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
      marginBottom: theme.spacing(3),
    },
  },
  voucherContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(3),
    },
  },
  voucherBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 1 30%',
    [theme.breakpoints.down('sm')]: {
      flex: 'none',
      width: '100%',
      maxWidth: '200px',
    },
  },
  qrImage: {
    width: '150px',
    height: '150px',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '300px',
      height: '300px',
      marginBottom: theme.spacing(1.5),
    },
  },
  voucherButton: {
    backgroundColor: 'transparent',
    color: theme.colors.ivory_beige,
    fontWeight: 'bold',
    fontSize: '0.8rem',
    textAlign: 'center',
    '&:hover': {
      color: theme.colors.golden_mustard,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
      padding: theme.spacing(1),
    },
  },
}));

export default useStyles;